
import React, { useState, useEffect } from "react";
import { Card, Typography, Box, Icon, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { keyframes } from "@mui/system";
import { toast } from "react-toastify";
import axios from "api/baseurl";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
// Keyframes for premium animations
const slideIn = keyframes`
  from { transform: translate(-50%, -20px); opacity: 0; }
  to { transform: translate(-50%, 0); opacity: 1; }
`;

const pulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 59, 48, 0.4); }
  70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(255, 59, 48, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 59, 48, 0); }
`;

// Styles for the notification with professional glassmorphism
const notificationStyle = {
    position: "fixed",
    top: "24px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 10000,
    minWidth: "380px",
    maxWidth: "95vw",
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    backdropFilter: "blur(12px) saturate(180%)",
    WebkitBackdropFilter: "blur(12px) saturate(180%)",
    borderRadius: "16px",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
    display: "flex",
    flexDirection: "column",
    animation: `${slideIn} 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)`,
    overflow: "hidden",
};

const SOSNotification = () => {
    const [notification, setNotification] = useState(null);
        const [dutydoctornotification, setDutyDoctorNotification] = useState(null);
const [renderingDoctorNotification, setRenderingDoctorNotification] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
const [actionLoading, setActionLoading] = useState(false);

    // Do not show SOS popup on the login page
    const isLoginPage = location.pathname === "/" || location.pathname === "/authentication/sign-in/basic";

    // Safely get login details
    const loginData = JSON.parse(localStorage.getItem("loginData"));

    const userid = loginData?.userid;
    const token = loginData?.token;
const role = loginData?.role; 

    const fetchNotification = async () => {
        if (
        isLoginPage ||
        !userid ||
        !token ||
        role !== "ROLE_CARE_COORDINATOR"   
    ) {
            setNotification(null);
            return;
        }

        try {
            const secretKey = await fetchSecretKey();

            // Using BaseUrl instead of raw axios to handle baseURL automatically if configured
            const response = await axios.get(`/api/alert/sos/${userid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.status === 200) {
                const decrypted = decryptBody(response.data, secretKey);

                const list = Array.isArray(decrypted) ? decrypted : (decrypted.notifications || []);

                if (list.length > 0) {
                    // Take the first one available
                    const latestSOS = list[0];
                    setNotification(latestSOS);
                } else {
                    setNotification(null);
                }
            }
        } catch (error) {
            console.error("Error fetching SOS notification:", error);
        }
    };

   useEffect(() => {
    if (
        !userid ||
        !token ||
        isLoginPage ||
        role !== "ROLE_CARE_COORDINATOR"   // 👈 ADD THIS
    ) return;

    fetchNotification();

    const interval = setInterval(() => {
        fetchNotification();
    }, 20000);

    return () => clearInterval(interval);

}, [userid, token, isLoginPage, role]);

 const fetchDutydoctorNotification = async () => {
        if (
        isLoginPage ||
        !userid ||
        !token ||
        role !== "ROLE_DUTY_DOCTOR"   
    ) {
            setDutyDoctorNotification(null);
            return;
        }

        try {
            const secretKey = await fetchSecretKey();

            // Using BaseUrl instead of raw axios to handle baseURL automatically if configured
            const response = await axios.get(`/api/dutydoctor/alerts/view-all-with-notes/${userid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.status === 200) {
                const decrypted = decryptBody(response.data, secretKey);

                const list = Array.isArray(decrypted) ? decrypted : (decrypted.notifications || []);

                if (list.length > 0) {
                    // Take the first one available
                    const latestSOS = list[0];
                    setDutyDoctorNotification(latestSOS);
                } else {
                    setDutyDoctorNotification(null);
                }
            }
        } catch (error) {
            console.error("Error fetching Critical notification:", error);
        }
    };
    const fetchRenderingDoctorNotification = async () => {
    if (
        isLoginPage ||
        !userid ||
        !token ||
        role !== "ROLE_RENDERING_DOCTOR"
    ) {
        setRenderingDoctorNotification(null);
        return;
    }

    try {
        const secretKey = await fetchSecretKey();

        const response = await axios.get(
            `/api/renderingdoctor/push-banner/${userid}`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );

        if (response.status === 200) {
            const decrypted = decryptBody(response.data, secretKey);

            const list = Array.isArray(decrypted)
                ? decrypted
                : (decrypted.notifications || []);

            if (list.length > 0) {
                const latestNotification = list[0];
                setRenderingDoctorNotification(latestNotification);
            } else {
                setRenderingDoctorNotification(null);
            }
        }
    } catch (error) {
        console.error(
            "Error fetching Rendering Doctor notification:",
            error
        );
    }
};

   useEffect(() => {
    if (
        !userid ||
        !token ||
        isLoginPage ||
        role !== "ROLE_DUTY_DOCTOR"   // 👈 ADD THIS
    ) return;

    fetchDutydoctorNotification();

    const interval = setInterval(() => {
        fetchDutydoctorNotification();
    }, 20000);

    return () => clearInterval(interval);

}, [userid, token, isLoginPage, role]);
useEffect(() => {
    if (
        !userid ||
        !token ||
        isLoginPage ||
        role !== "ROLE_RENDERING_DOCTOR"
    ) return;

    fetchRenderingDoctorNotification();

    const interval = setInterval(() => {
        fetchRenderingDoctorNotification();
    }, 20000);

    return () => clearInterval(interval);

}, [userid, token, isLoginPage, role]);
  const handleAction = async (id, sosid, actionType) => {
         if (actionLoading) return;
             setActionLoading(true);

        try {
            const secretKey = await fetchSecretKey();
            const payload = {
                alertId: sosid,
                action: actionType
            };
            const encryptedPayload = encryptBody(payload, secretKey);

            const response = await axios.post("/api/alert/action", encryptedPayload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "text/plain",
                },
            });

              if (response.status === 200) {

            // CLOSE POPUP
            setNotification(null);

            // CLOSE ALERT
            if (actionType === "CLOSE") {
                toast.success("Alert closed");
            }

            // OPEN ALERT
            if (actionType === "OPEN") {

                navigate("/track/sos-notifications", {
                    state: { highlightId: id }
                });
            }
        }
        } catch (error) {
            console.error(`Error performing action ${actionType}:`, error);
            toast.error(`Failed to ${actionType.toLowerCase()} alert`);
        } finally {
        setActionLoading(false);
    }
};
const handleRenderingDoctorAction = async (
    id,
    notificationId,
    actionType
) => {
    if (actionLoading) return;

    setActionLoading(true);

    try {
        const secretKey = await fetchSecretKey();

        const payload = {
            // userid: userid,
            notificationId: notificationId,
            action: actionType,
        };

        const encryptedPayload = encryptBody(payload, secretKey);

        const response = await axios.post(
            `api/renderingdoctor/action`,
            encryptedPayload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "text/plain",
                },
            }
        );

        if (response.status === 200) {

            // close popup
            setRenderingDoctorNotification(null);

            // navigate
            if (actionType === "OPEN") {
                navigate("/track/EscalatedCaseNotificationPage", {
                    state: { highlightId: id }
                });
            }
        }

    } catch (error) {
        console.error(
            `Error performing action ${actionType}:`,
            error
        );

        toast.error(
            `Failed to ${actionType.toLowerCase()} case`
        );
    } finally {
        setActionLoading(false);
    }
};
    const handleClick = async (id, notificationid, actionType) => {
         if (actionLoading) return;
             setActionLoading(true);

        try {
            const secretKey = await fetchSecretKey();
            const payload = {
                notificationId: notificationid,
                action: actionType
            };
            const encryptedPayload = encryptBody(payload, secretKey);

            const response = await axios.post(`/api/dutydoctor/alerts/action`, encryptedPayload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "text/plain",
                },
            });

            if (response.status === 200) {

            // CLOSE POPUP
            setDutyDoctorNotification(null);

            // SNOOZE
            if (actionType === "SNOOZE") {

                toast.success("Alert snoozed");
            }

            // OPEN
            if (actionType === "OPEN") {
    setDutyDoctorNotification(null);

    navigate("/track/critical-notifications");
    return;
}
        }

        } catch (error) {
            console.error(`Error performing action ${actionType}:`, error);
            toast.error(`Failed to ${actionType.toLowerCase()} alert`);
        } finally {
        setActionLoading(false);
    }
};

   if (
    role === "ROLE_CARE_COORDINATOR" &&
    !notification
) {
    return null;
}

if (
    role === "ROLE_DUTY_DOCTOR" &&
    !dutydoctornotification
) {
    return null;
}
if (
    role === "ROLE_RENDERING_DOCTOR" &&
    !renderingDoctorNotification
) {
    return null;
}
    return (
          <>
         {/* CARE COORDINATOR */}
        {role === "ROLE_CARE_COORDINATOR" && notification && (
        <Card sx={notificationStyle}>
            {/* Content Section */}
            <Box sx={{ p: 2.5, display: "flex", alignItems: "center", gap: 2.5 }}>
                <Box
                    sx={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        backgroundColor: "#ff3b30",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#fff",
                        flexShrink: 0,
                        animation: `${pulse} 2s infinite ease-in-out`,
                        boxShadow: "0 0 20px rgba(255, 59, 48, 0.4)"
                    }}
                >
                    <Icon sx={{ fontSize: "28px !important" }}>warning</Icon>
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            fontSize: "1rem",
                            lineHeight: 1.2,
                            color: "#1a1a1a",
                            mb: 0.5
                        }}
                    > 
                        {notification.patientName || "Emergency Alert"}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#666",
                            lineHeight: 1.4,
                            fontWeight: 400
                        }}
                    >
                        {notification.message || "Immediate assistance requested."}
                    </Typography>
                </Box>
            </Box>

            {/* Actions Section */}
            <Box sx={{ display: "flex", p: 1.5, pt: 0, gap: 1.5 }}>
                <Button
                    fullWidth
                        disabled={actionLoading}

                    variant="outlined"
                    onClick={() => handleAction(notification.id, notification.sosid, "CLOSE")}
                    sx={{
                        borderRadius: "10px",
                        py: 1.2,
                        textTransform: "none",
                        fontWeight: 600,
                        color: "#666",
                        borderColor: "#e0e0e0",
                        "&:hover": {
                            backgroundColor: "#f5f5f5",
                            borderColor: "#d0d0d0"
                        }
                    }}
                >
                    Close
                </Button>
                <Button
  fullWidth
  variant="contained"
  onClick={() => handleAction(notification.id, notification.sosid, "OPEN")}

  sx={{
                        borderRadius: "10px",
                        py: 1.2,
                        textTransform: "none",
                        fontWeight: 700,
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.25)",
                        "&:hover": {
                            backgroundColor: "#1565c0",
                            boxShadow: "0 6px 16px rgba(25, 118, 210, 0.35)",
                        }
                    }}
>
  Open Alert
</Button>
            </Box>
        </Card>
         )}
          {/* DUTY DOCTOR */}
        {role === "ROLE_DUTY_DOCTOR" &&
            dutydoctornotification && (
         <Card sx={notificationStyle}>
            {/* Content Section */}
            <Box sx={{ p: 2.5, display: "flex", alignItems: "center", gap: 2.5 }}>
                <Box
                    sx={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        backgroundColor: "#ff3b30",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#fff",
                        flexShrink: 0,
                        animation: `${pulse} 2s infinite ease-in-out`,
                        boxShadow: "0 0 20px rgba(255, 59, 48, 0.4)"
                    }}
                >
                    <Icon sx={{ fontSize: "28px !important" }}>warning</Icon>
                </Box>

                <Box sx={{ flex: 1 }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            fontSize: "1rem",
                            lineHeight: 1.2,
                            color: "#1a1a1a",
                            mb: 0.5
                        }}
                    >
                        {dutydoctornotification.patientName || "Emergency Alert"}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#666",
                            lineHeight: 1.4,
                            fontWeight: 400
                        }}
                    >
                        {dutydoctornotification.message || "Immediate assistance requested."}
                    </Typography>
                </Box>
            </Box>

            {/* Actions Section */}
            <Box sx={{ display: "flex", p: 1.5, pt: 0, gap: 1.5 }}>
                <Button
                    fullWidth
                        disabled={actionLoading}

                    variant="outlined"
                    onClick={() => handleClick( dutydoctornotification.id,dutydoctornotification.notificationId, "SNOOZE")}
                    sx={{
                        borderRadius: "10px",
                        py: 1.2,
                        textTransform: "none",
                        fontWeight: 600,
                        color: "#666",
                        borderColor: "#e0e0e0",
                        "&:hover": {
                            backgroundColor: "#f5f5f5",
                            borderColor: "#d0d0d0"
                        }
                    }}
                >
                    Snooze
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={() => handleClick(dutydoctornotification.notificationId, dutydoctornotification.notificationId, "OPEN")}
                    sx={{
                        borderRadius: "10px",
                        py: 1.2,
                        textTransform: "none",
                        fontWeight: 700,
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.25)",
                        "&:hover": {
                            backgroundColor: "#1565c0",
                            boxShadow: "0 6px 16px rgba(25, 118, 210, 0.35)",
                        }
                    }}
                >
                     Open Alert
                </Button>
            </Box>
        </Card>
         )}
         {/* RENDERING DOCTOR */}
{role === "ROLE_RENDERING_DOCTOR" &&
    renderingDoctorNotification && (
<Card sx={notificationStyle}>
    {/* Content Section */}
    <Box sx={{ p: 2.5, display: "flex", alignItems: "center", gap: 2.5 }}>
        <Box
            sx={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#ff3b30",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                flexShrink: 0,
                animation: `${pulse} 2s infinite ease-in-out`,
                boxShadow: "0 0 20px rgba(255, 59, 48, 0.4)"
            }}
        >
            <Icon sx={{ fontSize: "28px !important" }}>
                warning
            </Icon>
        </Box>

        <Box sx={{ flex: 1 }}>
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 700,
                    fontSize: "1rem",
                    lineHeight: 1.2,
                    color: "#1a1a1a",
                    mb: 0.5
                }}
            >
                {renderingDoctorNotification.patientName ||
                    "Emergency Alert"}
            </Typography>

            <Typography
                variant="body2"
                sx={{
                    color: "#666",
                    lineHeight: 1.4,
                    fontWeight: 400
                }}
            >
                {renderingDoctorNotification.message ||
                    "Immediate assistance requested."}
            </Typography>
        </Box>
    </Box>

    {/* Actions Section */}
    <Box sx={{ display: "flex", p: 1.5, pt: 0, gap: 1.5 }}>
        <Button
            fullWidth
            disabled={actionLoading}
            variant="outlined"
            onClick={() =>
                setRenderingDoctorNotification(null)
            }
            sx={{
                borderRadius: "10px",
                py: 1.2,
                textTransform: "none",
                fontWeight: 600,
                color: "#666",
                borderColor: "#e0e0e0",
                "&:hover": {
                    backgroundColor: "#f5f5f5",
                    borderColor: "#d0d0d0"
                }
            }}
        >
            Close
        </Button>

        <Button
            fullWidth
            variant="contained"
           onClick={() =>
    handleRenderingDoctorAction(
        renderingDoctorNotification.notificationId,
        renderingDoctorNotification.notificationId,
        "OPEN"
    )
}
            sx={{
                borderRadius: "10px",
                py: 1.2,
                textTransform: "none",
                fontWeight: 700,
                backgroundColor: "#1976d2",
                color: "#fff",
                boxShadow:
                    "0 4px 12px rgba(25, 118, 210, 0.25)",
                "&:hover": {
                    backgroundColor: "#1565c0",
                    boxShadow:
                        "0 6px 16px rgba(25, 118, 210, 0.35)",
                }
            }}
        >
            Open Case
        </Button>
    </Box>
</Card>
)}
    </>
    );
};

export default SOSNotification;
